jQuery.noConflict();
jQuery(document).ready(function () {
    if ($('.twosteps').length > 0) {
        $(".twosteps_descriptionstep2").hide();
        $(document).ready(function () {


            $(".twosteps_button1").click(function () {
                $("#twosteps_1").addClass("twosteps_actif")
                $("#twosteps_2").removeClass("twosteps_actif")
                if ($(".twosteps_descriptionstep1").is(":visible")) {
    
                }
                else {
                    if ($(".twosteps_descriptionstep1").is(":hidden")) {
                        $(".twosteps_descriptionstep1").show();

                        $(".twosteps_descriptionstep2").hide();
                    }
                }
            });

            $(".twosteps_button2").click(function () {
                
                $("#twosteps_2").addClass("twosteps_actif")
                $("#twosteps_1").removeClass("twosteps_actif")
                if ($(".twosteps_descriptionstep2").is(":visible")) {
                   
                }
                else {
                    if ($(".twosteps_descriptionstep2").is(":hidden")) {
                        $(".twosteps_descriptionstep2").show();

                        $(".twosteps_descriptionstep1").hide();
                    }
                }
            });
        });


    };
});
